import { requestAnimationFrame } from "src/helpers/requestAnimationFrame";

// https://github.com/morethanwords/tweb/blob/master/src/environment/userAgent.ts

//@ts-ignore
export const IS_TOUCH_SUPPORTED = ('ontouchstart' in window) || (window.DocumentTouch && document instanceof DocumentTouch);

export const USER_AGENT = navigator ? navigator.userAgent : null;
const ctx = typeof (window) !== 'undefined' ? window : self;

// https://stackoverflow.com/a/58065241
export const IS_APPLE_MOBILE = (/iPad|iPhone|iPod/.test(navigator.platform) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
  !(ctx as any).MSStream;

export const IS_SAFARI = !!('safari' in ctx) || !!(USER_AGENT && (/\b(iPad|iPhone|iPod)\b/.test(USER_AGENT) || (!!USER_AGENT.match(
  'Safari') && !USER_AGENT.match('Chrome'))))/*  || true */;
export const IS_MOBILE = navigator.maxTouchPoints > 0 && navigator.userAgent.search(
  /iOS|iPhone OS|Android|BlackBerry|BB10|Series ?[64]0|J2ME|MIDP|opera mini|opera mobi|mobi.+Gecko|Windows Phone/i) != -1;

export const IS_MOBILE_SAFARI = IS_SAFARI && IS_APPLE_MOBILE;

export const IS_STICKY_INPUT_BUGGED = IS_SAFARI && IS_MOBILE && IS_TOUCH_SUPPORTED;

export const doubleRaf = (cb: () => any) => {
  requestAnimationFrame(() => {
    requestAnimationFrame(cb);
  });
}

export const IS_SAMSUNG = navigator.userAgent.match(/SamsungBrowser/i)

if (IS_MOBILE_SAFARI) {
  document.addEventListener('dblclick', (e) => {
    e.preventDefault();
  })
}

const searchParams = new URLSearchParams(window.location.search);
export const isPwa = searchParams.get('mode') === 'pwa'
  || window.matchMedia('(display-mode: standalone)').matches
  || (navigator as any).standalone // safari;
export const pwaShortcut = isPwa ? searchParams.get('shortcut') : null;

export const supportPageOffset = window.pageXOffset !== undefined;
export const isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat');

export function currentOffset() {
  if (supportPageOffset) return window.pageYOffset;
  if (isCSS1Compat) return document.documentElement.scrollTop;
  return document.body.scrollTop;
}
